module.exports = __webpack_public_path__ + "post-listing-block-6-image-step1@2x-2BsB7v1.png";